module.exports = __webpack_public_path__ + "media/images/top/any_ogp-cf82e82b4b9b8ca1594b0e7976bb83b6.jpg";